import { useCallback, useContext, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { useAxios } from '../../hooks/use_axios'
import { useHandleMetadata } from '../../hooks/use_handle_metadata'
import {
  AppLocationContext,
  BLANK_APP_LOCATION,
  MENU_TAB,
} from '../../pages/admin/app_location_provider'
import { spamContactAction } from '../../reduxes/slices/contacts/actions'
import { getCurrentHandle } from '../../reduxes/slices/current/selectors'
import { getRoutes } from '../../reduxes/slices/routes/selectors'
import { getSelectedTopic } from '../../reduxes/slices/topics/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'

export const useUnknownContact = () => {
  const { setAppLocation } = useContext(AppLocationContext)
  const dispatch = useDispatch()
  const axios = useAxios()
  const routes: any = useSelectorDelegateStore(getRoutes)

  const search = useLocation().search
  const actionedHandle = new URLSearchParams(search).get('actioned_handle')
  const action = new URLSearchParams(search).get('spam_action') || ''

  const selectedTopic = useSelector<any, any>(getSelectedTopic)
  const currentHandle = useSelector(getCurrentHandle)

  const [showMessages, setShowMessages] = useState(false)
  const [dialogVisible, setDialogVisible] = useState<boolean>(!!actionedHandle)
  const [dialogAction, setDialogAction] = useState<string>(action)

  const handle: string = useMemo(() => {
    if (selectedTopic?.participant_mode === 'group_chat') {
      return selectedTopic.created_by_handle
    } else if (selectedTopic?.participant_mode === 'direct_chat') {
      return selectedTopic.contact_handles.find(
        (h: string) => h !== currentHandle,
      )
    } else {
      return currentHandle
    }
  }, [currentHandle, selectedTopic])
  let unknownContact: boolean

  const handleReport = useCallback(
    (reason: string) => {
      const promise: any = dispatch(
        axios(spamContactAction(handle, 'report', reason)),
      )
      promise.then(() => {
        setDialogVisible(false)
        setAppLocation({
          ...BLANK_APP_LOCATION,
          menuTab: MENU_TAB.DIRECT_CHATS,
          url: routes.admin_app_root.path,
        })
      })
    },
    [axios, dispatch, handle, routes.admin_app_root.path, setAppLocation],
  )

  const handleBlock = useCallback(
    (reason: string) => {
      const promise: any = dispatch(
        axios(spamContactAction(handle, 'report', reason)),
      )
      promise.then(() => {
        setDialogVisible(false)
        setAppLocation({
          ...BLANK_APP_LOCATION,
          menuTab: MENU_TAB.DIRECT_CHATS,
          url: routes.admin_app_root.path,
        })
      })
    },
    [axios, dispatch, handle, routes.admin_app_root.path, setAppLocation],
  )

  const confirmAction = useCallback(
    (reason: string) => {
      switch (dialogAction) {
        case 'report':
          handleReport(reason)
          break
        case 'block':
          handleBlock(reason)
          break
        default:
          break
      }
    },
    [handleBlock, handleReport, dialogAction],
  )

  const toggleAction = useCallback((value: string) => {
    setDialogVisible(true)
    setDialogAction(value)
  }, [])

  const { contact, name } = useHandleMetadata(handle)

  if (contact === null || contact === undefined) {
    unknownContact = true
  } else {
    unknownContact = contact.blocked_status === 'unknown'
  }

  return {
    name,
    unknownContact,
    contact,
    handle,
    participantMode: selectedTopic?.participant_mode,
    showMessages,
    setShowMessages,
    dialogVisible,
    setDialogVisible,
    confirmAction,
    toggleAction,
    dialogAction,
  }
}
